import React, { FC } from "react"

import { Divider, Grid, Switch, Text, useMantineColorScheme, useMantineTheme } from "@mantine/core"
import { IconEyeCog, IconMoonStars, IconSun } from "@tabler/icons-react"

import SettingsCard from "../settings-card/SettingsCard"
import LanguageSelect from "../../../components/inputs/language-select/LanguageSelect"
import { useLanguage } from "../../../contexts/language-context"

const AppearanceSettingsCard: FC = () => {
    const { colorScheme, toggleColorScheme } = useMantineColorScheme()
    const theme = useMantineTheme()
    const { code, setCode, L } = useLanguage()

    return (
        <SettingsCard title={L("Appearance")} icon={IconEyeCog}>
            <Grid align="center">
                <Grid.Col span={4}>
                    <Text>{L("Language")}</Text>
                </Grid.Col>
                <Grid.Col span={8}>
                    <LanguageSelect onChange={setCode} value={code} maw={360} withinPortal />
                </Grid.Col>
                <Grid.Col span={12}>
                    <Divider />
                </Grid.Col>
                <Grid.Col span={4}>
                    <Text>{L("Color theme")}</Text>
                </Grid.Col>
                <Grid.Col span={8}>
                    <Switch
                        checked={colorScheme === "dark"}
                        onChange={() => toggleColorScheme()}
                        size="lg"
                        onLabel={<IconSun color={theme.white} size={20} stroke={1.5} />}
                        offLabel={<IconMoonStars color={theme.colors.gray[6]} size={20} stroke={1.5} />}
                    />
                </Grid.Col>
            </Grid>
        </SettingsCard>
    )
}

export default AppearanceSettingsCard
